import { render, staticRenderFns } from "./importTool.vue?vue&type=template&id=b423ae64&scoped=true"
import script from "./importTool.vue?vue&type=script&lang=js"
export * from "./importTool.vue?vue&type=script&lang=js"
import style0 from "./importTool.vue?vue&type=style&index=0&id=b423ae64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b423ae64",
  null
  
)

export default component.exports